import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Header = styled.div`
  ${props => (props.theme.isMobile ? `
    padding: 0 20px;
    margin: 0 -20px;
  ` : `
    padding: 0 26px;
    margin: 0 -26px;
  `)};
  margin-bottom: -10px;
  background: ${props => props.theme.secondaryColorLightest};
  border-radius: 4px;
  border: 1px solid ${props => props.theme.secondaryColorLight};
  height: 47px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  justify-content: start;
  color: ${props => props.theme.bodyColor};
`;

const Prefix = styled.span`
  white-space: nowrap;
  font-size: ${props => (props.theme.isMobile ? 13 : 16)}px;
  flex-grow: 1;
  margin-right: 4px;
`;

const QueryString = styled.span`
  white-space: nowrap;
  font-size: ${props => (props.theme.isMobile ? 13 : 16)}px;
  flex-grow: 100;
  overflow-x: hidden;
  text-overflow: ellipsis;
  color: ${props => props.theme.primaryColor};
`;

const Count = styled.span`
  white-space: nowrap;
  font-size: 12px;
  flex-grow: 1;
  margin-left: 4px;
`;

export default function WireMatchHeader({ query, text, n }) {
  const plural = n > 1 ? 's' : '';
  return (
    <Header>
      <Prefix>{`wire${plural} ${text}`}</Prefix>
      <QueryString>{query}</QueryString>
      <Count>{`${n} result${plural}`}</Count>
    </Header>
  );
}

WireMatchHeader.propTypes = {
  query: PropTypes.string.isRequired,
  text: PropTypes.oneOf(['titled', 'similar to', 'published by', 'mentioning', 'tagged']).isRequired,
  n: PropTypes.number.isRequired,
};
